import {z} from '@hono/zod-openapi';

const serviceCampaignSchema = z.object({
  id: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  kind: z.enum(['PREVIOUS_CAMPAIGN', 'ACTIVE_CAMPAIGN']).nullable().optional(),
  state: z
    .enum(['DONE', 'CANCELLED', 'CLOSED', 'ACTIVE', 'RELEASED_NON_ACTIVE'])
    .nullable()
    .optional(),
  stateDate: z.string().nullable().optional(),
  defectCode: z.string().nullable().optional(),
  startDate: z.string().nullable().optional(),
  dueDate: z.string().nullable().optional(),
  serviceOrder: z
    .object({
      id: z.string().nullable().optional(),
      state: z.string().nullable().optional(),
      serviceCaseId: z.string().nullable().optional(),
      serviceJob: z
        .object({
          id: z.string().nullable().optional(),
        })
        .nullable()
        .optional(),
    })
    .nullable()
    .optional(),
});

export type ServiceCampaign = z.infer<typeof serviceCampaignSchema>;

export const vehicleServiceCampaignResponseSchema = z
  .object({
    platformCode: z.string().nullable().optional(),
    serviceCode: z.string().nullable().optional(),
    serviceCampaign: z.array(serviceCampaignSchema).optional(),
  })
  .nullable();

export type VehicleServiceCampaignResponse = z.infer<typeof vehicleServiceCampaignResponseSchema>;
